// extracted by mini-css-extract-plugin
export default {"content-wrapper":"choose-technicians_content-wrapper__cSKMB","content":"choose-technicians_content__4b0rt","technician-list":"choose-technicians_technician-list__selZY"};